import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useOktaAuth } from "@okta/okta-react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

function RequiredAuth() {
  const { oktaAuth, authState } = useOktaAuth();

  useEffect(() => {
    if (!authState) return;
    if (!authState.isAuthenticated) {
      oktaAuth.setOriginalUri(window.location.href);
      oktaAuth.signInWithRedirect();
    }
  }, [oktaAuth, authState]);

  if (!authState || !authState.isAuthenticated) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="50vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return <Outlet />;
}

export { RequiredAuth };
